import { z } from 'zod'
import { DEFAULT_USAGE_PAGE_SIZE, ERROR_CODES, MAX_USAGE_PAGE_SIZE } from '../constants.ts'

/** Every non-2xx response from the API has this shape. */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(Object.values(ERROR_CODES) as [string, ...string[]]),
    message: z.string(),
    details: z.unknown().optional(),
  }),
})

export type ApiError = z.infer<typeof apiErrorSchema>

export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_USAGE_PAGE_SIZE).default(DEFAULT_USAGE_PAGE_SIZE),
})

export type PaginationQuery = z.infer<typeof paginationQuerySchema>

export const paginationMetaSchema = z.object({
  page: z.number().int(),
  pageSize: z.number().int(),
  total: z.number().int(),
  totalPages: z.number().int(),
})

export type PaginationMeta = z.infer<typeof paginationMetaSchema>

export function paginatedSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    data: z.array(item),
    pagination: paginationMetaSchema,
  })
}

/** A calendar date in Asia/Jakarta, `YYYY-MM-DD`. */
export const businessDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a YYYY-MM-DD date')

export const isoDateTimeSchema = z.string().datetime({ offset: true })
